import React from "react";
import { DangerNotify, DangerNotifyMedium } from "../svg/Index";

const ErrorMsg: React.FC<IErrorMsg> = (props) => {
  const { error, className = "text-error" } = props;

  return (
    <>
      {error ? (
        <div className={className}>
          {className == "text-error" ? (
            <span className="me-1">
              <DangerNotifyMedium />
            </span>
          ) : (
            <span>
              <DangerNotify />
            </span>
          )}
          <span>{error}</span>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default ErrorMsg;
